import { header } from './modules/header';
import { animation } from './modules/animation';
import { accordion } from './modules/accordion';
import { modal } from './modules/modal';
header();
animation();
accordion();
modal();
